import { ViewStatusFlagCard } from "app/features/statusFlags/organisms/ViewStatusFlagCard";
import { useGetStatusFlagsIndexQuery } from "app/services/api/statusFlagsApi";
import { useState } from "react";
import { Text, ScrollView, View } from "react-native";
import LoadingSpinner from "ui/atoms/spinner/LoadingSpinner";
import { Button, ButtonText } from "ui/gluestack/button";
import { useResidentContext } from "../provider/ResidentProvider";
import { useRouter } from "expo-router";
import { useResidentStatusFlags } from "../hooks/useResidentStatusFlags";
import { useAssignStatusFlags } from "../hooks/useAssignStatusFlags";
import { AssignStatusFlagsModal } from "./modals/AssignStatusFlagsModal";

export default function ResidentStatusFlagsTemplate() {
  const { data: allFlags, isLoading: isAllFlagsLoading } =
    useGetStatusFlagsIndexQuery();
  const { residentId } = useResidentContext();
  const router = useRouter();

  const [isAssignModalVisible, setAssignModalVisible] = useState(false);

  const {
    matchedFlagIds,
    setMatchedFlagIds,
    isLoading: isResidentFlagsLoading,
  } = useResidentStatusFlags(residentId!);

  const { handleAssignFlags, isAssigning } = useAssignStatusFlags(() => {
    handleAssignSuccess();
  });

  const handleAssign = (flagId: number, isChecked: boolean) => {
    setMatchedFlagIds((prev) => {
      const updated = isChecked
        ? [...prev, flagId]
        : prev.filter((id) => id !== flagId);
      return updated;
    });
  };

  const goBack = () => {
    router.back();
  };

  const handleAssignSuccess = () => {
    setAssignModalVisible(false);
    goBack();
  };

  const handleConfirmAssign = () => {
    handleAssignFlags({
      residentId: residentId!,
      statusFlagIds: matchedFlagIds,
    });
  };

  if (isAllFlagsLoading || isResidentFlagsLoading) {
    return (
      <View className="flex-1 justify-center items-center my-10">
        <LoadingSpinner />
      </View>
    );
  }

  return (
    <View className="flex-1 bg-white">
      <AssignStatusFlagsModal
        isVisible={isAssignModalVisible}
        onClose={() => setAssignModalVisible(false)}
        isAssigning={isAssigning}
        onSubmit={handleConfirmAssign}
      />
      <ScrollView contentContainerClassName="px-dashboard flex-1 flex">
        {allFlags?.length ? (
          <View className="bg-secondary-0 rounded-lg gap-4 grid md:grid-cols-2 p-5">
            {allFlags.map((flag) => (
              <ViewStatusFlagCard
                key={flag.id}
                flag={flag}
                isSelected={matchedFlagIds.includes(flag.id)}
                onAssign={handleAssign}
              />
            ))}
          </View>
        ) : (
          <View className="flex-1 my-5">
            <Text className="text-typography-600">
              No status flags have been created yet.
            </Text>
          </View>
        )}
      </ScrollView>
      <View className="flex flex-row justify-end gap-x-4 mt-10 pb-4">
        <Button action="primary" size="sm" variant="outline" onPress={goBack}>
          <ButtonText className="text-primary-500 font-semibold">
            Cancel
          </ButtonText>
        </Button>
        <Button
          action="primary"
          size="sm"
          isDisabled={matchedFlagIds.length === 0}
          onPress={() => setAssignModalVisible(true)}
        >
          <ButtonText>Update Status</ButtonText>
        </Button>
      </View>
    </View>
  );
}
